import axios from "axios";

export const getSection3 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/about-page-s3-catalyze?populate=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
